/* eslint-disable no-nested-ternary */
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import CompanyDocumentCard from 'Components/document/CompanyDocumentCard';
import {
  selectBatchUploading,
  selectCreateFolderPopupData,
  selectCurrentFolder,
  selectCurrentHubView,
  selectDocumentHubHeader,
  selectDrawerOpen, selectEntities, selectFromGlobalSearch,
  selectItemCount,
  selectNextUploadDocuments,
  selectSapRadio,
  selectSearchList, selectSearchTerm,
  selectUploadCancelled,
  selectUploadedByMe,
  selectUploadedDocuments,
} from 'Selector/DocumentHubSelector';
import { CANCEL_UPLOAD_POPUP, SMART_REDIRECTION_TEXT, TOOLTIP_DOCUMENT_HUB } from 'Utils/Constants';
import {
  SecondaryColor, greyColor, maxMobile, maxTablet, maxWidth, midWidthApp,
  primaryColor, primaryFont, primaryHeadingColor, retina, secondaryFont, smMobile400, wLight, wMBold, wMedium,
  xmMobile,
} from 'Utils/utilsStyle';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions } from 'Slice/DocumentHubSlice';
import {
  Radio, Switch, Tooltip,
} from 'antd';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import GlobalButton from 'Components/common/components/GlobalButton';
import AddPlusIcon from 'Components/common/assets/svgIcons/AddPlusIcon';
import UploadDocumentIcon from 'Components/common/assets/svgIcons/UploadDocumentIcon';
import {
  IsMobile, IsMobileSm400, IsTablet, formatNumberWithCommas, removeQueryParam, valueToObject,
} from 'Utils/UtilityFunctions';
import { selectShowUploadDocument } from 'Selector/GlobalSearchContentSelector';
import { selectActivetype, selectHighlight } from 'Selector/CertificationSelector';
import { chatStates } from 'Components/layout/headers/NavBarPrimary';
import CreateFolderPopup from 'Components/common/modal/CreateFolderPopup';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDocumentHubSelection } from 'Utils/hooks/useDocumentHubSelection';

const StyleSheet = styled.div`
&.container-heading-div {
   width: 100%;
    &.sapStyleWrapper {
      flex-direction: column;
      align-items: unset;
      justify-content: unset;
      padding: 0px;
      .sap-document-hub-header-primary {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        width: 100%;
        .left-side {
          display: flex;
          align-items: center;
          column-gap: 8px;
          .back-button-div {
            margin-top: 4px;
          }
          .docs-title-sap {
            color: #5E7079;
            font-family: ${primaryFont};
            font-size: 18px;
            font-weight: ${wMedium};
            line-height: 20px;
            letter-spacing: -0.556px;
            @media all and (max-width: ${maxMobile}) {
              font-size: 16px;
            }
          }
        }
        .right-side {
          .search-wrapper {
            width: 192px;
            @media all and (max-width: ${maxMobile}) {
              width: 150px;
            }
            margin: 0px;
            .ant-input-affix-wrapper {
              height: 32px;
              .ant-input-prefix {
                display: none;
              }
              .ant-input {
                font-size: 14px;
                font-weight: 400;
                margin: 0px;
                .ant-input-affix-wrapper {
                  height: 32px;
                  z-index: 0;
                  &:target,
                  &:enabled,
                  &:hover,
                  &:active,
                  &:focus{
                    z-index: 0;
                  }
                  .ant-input-prefix {
                    @media all and (max-width: ${maxMobile}) {
                      display: none;
                    }
                  }
                  .cross-icon {
                    top: 7px;
                    right: 9px;
                  }
                }
              }
            }
            .cross-icon {
              top: 8px;
              right: 10px;
            }
          }
        }
      }
      .sap-document-hub-header-sub-primary {
        display: flex;
        align-items: center;
        .radio-text {
          display: flex;
          align-items: center;
          &:last-child {
            margin-left: 16px;
          }
          .radio-title {
            color: #5E7079;
            font-family: ${primaryFont};
            font-size: 14px;
            font-style: normal;
            font-weight: ${wMedium};
            line-height: 20px;
            letter-spacing: -0.556px;
          }
        }
      }
    }
    .document-heading {
    &.documentHeader {
      .left-side {
        width: calc(100% - 560px);
        @media all and (max-width: ${maxMobile}) {
          width: 100%;
        }
        .company-info-hub-div {
          width: 100%;
          @media all and (max-width: ${maxMobile}) {
            width: calc(100% - 315px);
            min-width: 170px;
          }
          svg {
            min-width: 25px;
          }
          .right-side-wrap {
            width: calc(100% - 30px);
          }
        }
      }
    }
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 30px 20px;
      @media all and (max-width: ${maxMobile}) {
        flex-direction: column;
        align-items: flex-start;
        padding: 30px 0px 0px;
      }
      .left-side {
        display: flex;
        align-items: center;
        @media all and (max-width: ${maxMobile}) {
          padding: 0 17px;  
          width: 100%;
          justify-content: space-between;
        }
        @media all and (max-width: ${maxMobile}) {
          position: relative;
        }
        .company-info-hub-div {
          display: flex;
          align-items: center;
          .back-icon-svg {
            /* margin-top: 10px; */
          }
          .heading {
            color: ${primaryHeadingColor};
            font-family: ${secondaryFont};
            font-size: 26px;
            font-weight: ${wMBold};
            line-height: 30px;
            margin-bottom: 0px;
            border-left: 1px solid #DDDDDD;
            padding: 4px 0px 4px 12px;
            margin-left: 12px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              font-size: 26px;
              line-height: 30px;
            }
            @media all and (max-width: ${maxTablet}) {
              font-size: 20px;
              line-height: 24px;
            }
          }
          .right-side-wrap {
            display: flex;
            flex-direction: column;
            position: relative;
          }
          .heading-and-tip {
            display: flex;
            align-items: center;
          }
        }
        .search-wrapper {
          margin: 0px;
          margin-right: 13px;
          &.iconModeSearch {
            .ant-input-prefix {
            svg {
              @media all and (max-width: ${maxWidth}){
                margin-left: 1px;
              }
            } 
            }
          }
          .ant-input-affix-wrapper {
            input  {
              font-size: 18px;
              letter-spacing: -0.45px;
              @media all and (max-width: ${maxWidth}), ${retina}{
                font-size: 14px;
                line-height: 16px;
              }
              ::placeholder {
                font-weight: ${wLight};
              }
            }
          }
        }
      }
      .right-side {
        &.nodocumnetBtn {
          .search-div {
            .search-wrapper {
              margin-right: 0px;
            }
          }
        }
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 10px;
        .gill-roy-tip {
          margin-top: 0px;
        }
        .triggers-bullet-tooltip{
          .ant-tooltip{
            z-index: 1;
            @media (max-width: ${maxTablet}) {
              display: none;
            }
          }  
        }
        @media all and (max-width: ${maxMobile}) {
          width: 100%;
          justify-content: flex-end;
          padding: 0 15px;
          margin-top: 20px;
        }
        .toggle-div {
          display: flex;
          align-items: center;
          margin-right: 16px;
          .toggle-text {
            color: ${greyColor};
            font-family: ${primaryFont};
            font-size: 14px;
            font-weight: ${wMedium};
            line-height: 20px;
            letter-spacing: -0.4px;
            margin-right: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            @media screen and (max-width: ${midWidthApp}) {
              max-width: 50px;
            }
          }
        }
        .search-div {
          position: relative;
          .search-wrapper{
            .ant-input-affix-wrapper {
              padding: 6.5px 30px 6.5px 17px;
              height: 31px;
              @media all and (max-width: ${maxWidth}), ${retina}{
                height: 31px;
              }
              .ant-input-prefix {
                display: none;
              }
              .ant-input  {
                font-size: 14px;
                font-weight: ${wLight};
                @media all and (max-width: ${maxWidth}), ${retina}{
                  font-size: 14px;
                  line-height: 16px;
                }
              }
              .ant-input::placeholder {
                font-weight: ${wLight} !important;
              }
            }
            .cross-icon {
              cursor: pointer;
              top: 8px;
              right: 12px;
            }
            &.iconModeSearch {
                width: 30px;
                .ant-input-affix-wrapper { 
                  padding: 0px;
                  .ant-input-prefix {
                    display: flex;
                    svg {
                      margin-left: 0px;
                    }
                  }
                }
            }
            width: 204px;
            margin: 0px 0px 0px 0px;
            @media all and (max-width: ${maxWidth}), ${retina}{
              width: 204px;
            }
          }
        }
        .upload-document-btn {
          font-family: ${primaryFont};
          font-size: 12px;
          font-weight: ${wMedium};
          line-height: 14px;
          .upload-document-svg {
            width: 11px;
            height: 12px;
            margin-right: 8px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 15px;
              height: 17px;
            }
            @media all and (max-width: 577px) {
              margin-right: 0px;
            }
          }
        }
        .create-folder-btn {
          font-family: ${primaryFont};
          font-size: 12px;
          font-weight: ${wMedium};
          line-height: 14px;
          .add-plus-icon {
            width: 10px;
            height: 10px;
            margin-right: 8px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 14px;
              height: 14px;
            }
            @media all and (max-width: 577px) {
              margin-right: 0px;
            }
          }
          @media all and (max-width: ${smMobile400}) {
            margin-right: 12px;
          }
        }
        .skeleton-box {
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }
`;

const TotalCount = styled.div`
  color: ${primaryColor};
  font-family: ${primaryFont};
  font-size: 14px;
  font-style: normal;
  font-weight: ${wMedium};
  line-height: 24px;
  letter-spacing: -0.292px;
  padding-left: 26px;
  white-space: nowrap;
  position: absolute;
  top: 40px;
  @media all and (max-width: ${maxWidth}), ${retina} { 
    padding-left: 25px;
  }
  @media all and (max-width: ${maxTablet}) {
    top: 35px;
    padding-left: 27px;
  }
  @media all and (max-width: ${maxMobile}) {
    top: 30px;
  }
`;
type Props = {
  inSmartDrawer?: boolean,
  inGlobalSearch?: boolean,
  loading: boolean,
  loaded: boolean
} & typeof defaultProps;

const defaultProps = {
  inSmartDrawer: false,
  inGlobalSearch: false,
};

const DocumentHubHeader = function DocumentHubHeader(props: Props) {
  const {
    inSmartDrawer, inGlobalSearch, loaded, loading,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const smMob = IsMobileSm400();
  const isMob = IsMobile();
  const isTab = IsTablet();
  const [showCount, setShowCount] = useState(false);
  const showUploadDocument = useSelector(selectShowUploadDocument);
  const itemCount = useSelector(selectItemCount);
  const formattedDocumentCount = formatNumberWithCommas(itemCount);
  const uploadedDocuments = useSelector(selectUploadedDocuments);
  const sapRadio = useSelector(selectSapRadio);
  const searchTerm = useSelector(selectSearchTerm);
  const entities = useSelector(selectEntities);
  const uploadedByMe = useSelector(selectUploadedByMe);

  const onBackSelectedDocs = () => {
    dispatch(actions.resetDocumentHub());
  };
  const searchList = useSelector(selectSearchList);
  const [query, setQuery] = useState<string>('');
  const host = window.location.href;
  const drawerOpen = useSelector(selectDrawerOpen);
  const batchUploading = useSelector(selectBatchUploading);
  const uploadCancelled = useSelector(selectUploadCancelled);
  const nextUploadDocuments = useSelector(selectNextUploadDocuments);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const currentView = useSelector(selectCurrentHubView);
  const currentFolder = useSelector(selectCurrentFolder);
  const fromGlobalSearch = useSelector(selectFromGlobalSearch);
  const { saveProfileName: saveProfileNameV2 } = chatStates;
  const {
    name: hubName, logo, type,
  } = useSelector(selectDocumentHubHeader);
  const [searchParams] = useSearchParams();
  let isUpload = searchParams.get('isUpload') === 'true';

  const name = currentFolder ? currentFolder.name : hubName;

  const uploadAllow = !currentFolder || currentFolder?.isSharedFolder === 1 || currentFolder?.isAdmin === 1 || currentFolder?.isDelegateAdmin === 1 || currentFolder?.isOwner === 1 || currentFolder?.editAccess === 1;

  useEffect(() => {
    if (isUpload && loaded && showUploadDocument) {
      const element = document.getElementsByClassName('upload-document-btn')[0];
      setTimeout(() => {
        (element as HTMLElement)?.click();
        searchParams.set('isUpload', 'false');
        isUpload = false;
        removeQueryParam('isUpload');
      }, 500);
    }
  }, [isUpload, loaded]);

  const { handleCheckAll } = useDocumentHubSelection();
  const {
    visible,
  } = useSelector(selectCreateFolderPopupData);
  useEffect(() => {
    if (!loading && loaded) {
      setShowCount(true);
    }
  }, [loaded]);

  useEffect(() => {
    if (sapRadio === 'document' && inSmartDrawer) {
      handleCheckAll(true);
    } else if (sapRadio === 'custom') {
      dispatch(actions.resetSelectedDocuments(true));
    }
  }, [sapRadio]);

  const redirectFrom = () => {
    if (saveProfileNameV2 && !saveProfileNameV2.includes(SMART_REDIRECTION_TEXT)) {
      return 'gilroy';
    }
    if (inSmartDrawer) {
      return 'smartAccountPlan';
    }
    return 'docHub';
  };

  const onSearching = (value: string) => {
    dispatch(actions.setSapSelectedDocOffset(0));
    const trimmedValue = value.trim();
    searchList?.some((item) => {
      if (item.searchTerm === trimmedValue) {
        dispatch(actions.setIsSearchSelectAll(item.isSelectAll));
        return true;
      }
      dispatch(actions.setIsSearchSelectAll(false));
      return false;
    });
    if (trimmedValue.length && searchTerm !== trimmedValue) {
      dispatch(actions.setSearchText(trimmedValue));
      setQuery(trimmedValue);
      dispatch(flurryActions.callFlurryEvent(valueToObject(
        'documentHub_search_performed',
        0,
        {
          search_term: trimmedValue,
          host,
        },
      )));
    } else if (searchTerm.length && !trimmedValue.length) {
      dispatch(actions.setSearchText(''));
      setQuery('');
    }
  };

  useEffect(() => {
    if (!searchTerm.length) {
      setQuery('');
    }
  }, [searchTerm]);

  const handleUserDocumentsOnlyChange = (checked: boolean) => {
    setShowCount(false);
    dispatch(actions.setUploadedByMe(checked));
  };

  const toggleDrawer = () => {
    if (drawerOpen && ((batchUploading && !uploadCancelled)
      || (uploadCancelled && nextUploadDocuments.length))) {
      dispatch(actions.setCancelPopup({
        popupText: CANCEL_UPLOAD_POPUP,
        okButtonText: 'Yes',
        cancelButtonText: 'No',
      }));
    } else {
      dispatch(actions.setDrawerOpen(!drawerOpen));
      if (isHighlight && currentType === 'document_hub_panel') {
        dispatch(certificationActions.setHighlight(false));
        dispatch(certificationActions.setIsHighlighted(true));
      }
    }
  };
  const handleUploadClick = () => {
    toggleDrawer();
    if (!drawerOpen) {
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_upload_intent', 0, {
        redirection_from: redirectFrom(),
        host,
      })));
    }
  };

  const handleBack = () => {
    if (fromGlobalSearch) {
      dispatch(actions.setFromGlobalSearch(false));
      navigate(-1);
    } else {
      dispatch(actions.resetDocumentHub());
    }
  };

  return (
    <StyleSheet className={
      classNames(
        `${!inGlobalSearch ? 'container-heading-div' : ''}`,
        { sapStyleWrapper: inSmartDrawer },
      )
    }
    >
      {inSmartDrawer ? (
        <div className="sap-document-hub-header-primary">
          {loading && !loaded && !name ? (
            <div className="left-side">
              <SkeletonCustom
                height="30px"
                width="190px"
              />
            </div>
          ) : (
            <div className="left-side">
              {currentView === 'document' ? (
                <div className={classNames('back-button-div', { disabled: loading })}>
                  <BackIcon
                    onClick={onBackSelectedDocs}
                  />
                </div>
              ) : null}
              <span className="docs-title-sap text-truncate">
                {currentView !== 'document' ? ' Select Documents' : currentFolder?.name || ''}
              </span>
            </div>
          )}
          {
            !loaded && loading && !name ? (
              <div className="right-side">
                {[1, 2].map(() => (
                  <SkeletonCustom
                    height="30px"
                    width="90px"
                  />
                ))}
              </div>
            ) : (
              <div className="right-side">
                <AlertsSearch
                  placeholderText={currentView === 'document' ? 'Search documents' : 'Search folders'}
                  onSearching={onSearching}
                  iconMode={isTab}
                  query={query}
                  loading={(loading && !loaded) || (!entities.length && !uploadedDocuments.length && !searchTerm.length)}
                />
              </div>
            )
          }
        </div>
      ) : (
        <div className={classNames('document-heading', { documentHeader: currentView === 'document' })}>
          {loading && !loaded && !name ? (
            <div className="left-side">
              <SkeletonCustom
                height="30px"
                width="190px"
              />
            </div>
          ) : (
            <div className="left-side">
              {!inGlobalSearch ? (
                <div className="company-info-hub-div">
                  {type === 'document' ? <BackIcon onClick={handleBack} /> : <CompanyDocumentCard logo={logo} />}

                  <div className="right-side-wrap">
                    <div className="heading-and-tip">
                      <h3 className="heading text-truncate-one-line">
                        {`${currentFolder ? currentFolder.name : name}'s hub`}
                      </h3>
                      <HeadingWithToolTip
                        classNameOverlay="doc-tooltip-layer"
                        toolTipText={TOOLTIP_DOCUMENT_HUB}
                        getPopupContainer=".sub-container-document-hub"
                      />
                    </div>
                    {!showCount ? null : (
                      <div>
                        <TotalCount>
                          {`Total ${type === 'document' ? 'Documents' : searchTerm.length ? 'Items' : 'Folders'}`}
                          {uploadedByMe ? ' uploaded by user' : ''}
                          :
                          {' '}
                          {formattedDocumentCount}
                        </TotalCount>
                      </div>
                    )}
                  </div>

                </div>
              ) : null}
              {isMob
                ? (
                  <div className="search-div">
                    <AlertsSearch
                      placeholderText={currentView === 'document' ? 'Search documents' : 'Search folders'}
                      onSearching={onSearching}
                      iconMode={isTab && !inSmartDrawer}
                      query={query}
                      loading={(loading && !loaded) || (!entities.length && !uploadedDocuments.length && !searchTerm.length)}
                    />
                  </div>
                ) : null}
            </div>
          )}
          {
            !loaded && loading && !name ? (
              <div className="right-side">
                {[1, 2].map(() => (
                  <SkeletonCustom
                    height="30px"
                    width="90px"
                  />
                ))}
              </div>
            ) : (
              <div className={classNames('right-side', { nodocumnetBtn: !showUploadDocument })}>
                {!isMob
                  ? (
                    <>
                      {!inSmartDrawer && !inGlobalSearch
                        ? (
                          <div className="toggle-div">
                            <span className="toggle-text">
                              My
                              {' '}
                              {`${currentView === 'document' ? 'documents' : 'folders'}`}
                            </span>
                            <Switch
                              className="switch-div"
                              disabled={loading}
                              checkedChildren="Off"
                              unCheckedChildren="On"
                              checked={!uploadedByMe}
                              onChange={(checked) => handleUserDocumentsOnlyChange(!checked)}
                            />
                          </div>
                        ) : null}
                      {!inGlobalSearch && (
                        <div className="search-div">
                          <AlertsSearch
                            placeholderText={currentView === 'document' ? 'Search documents' : 'Search folders'}
                            onSearching={onSearching}
                            iconMode={isTab}
                            query={query}
                            loading={(loading && !loaded) || (!entities.length && !uploadedDocuments.length && !searchTerm.length)}

                          />
                        </div>
                      )}
                    </>
                  ) : null}
                {isMob && !inSmartDrawer && !inGlobalSearch
                  ? (
                    <div className="toggle-div">
                      <span className="toggle-text">
                        My
                        {`${currentView === 'document' ? 'documents' : 'folders'}`}
                      </span>
                      <Switch
                        className="switch-div"
                        checkedChildren="Off"
                        unCheckedChildren="On"
                        checked={!uploadedByMe}
                        onChange={(checked) => handleUserDocumentsOnlyChange(!checked)}
                      />
                    </div>
                  ) : null}
                {showUploadDocument
                  ? (
                    <>
                      {(currentView === 'folder' || currentView === 'both') && !inSmartDrawer ? (
                        <GlobalButton
                          title={isMob ? '' : 'Create Folder'}
                          IconLeft={<AddPlusIcon color="#fff" />}
                          LeftSpace={smMob ? '' : '12px'}
                          PaddingSm="5px 10px"
                          innerSpace="8px 14px"
                          heightSm="30px"
                          height="30px"
                          bgColor={primaryColor}
                          textColor="#fff"
                          onButtonClick={() => dispatch(actions.setCreateFolderPopupVisible(true))}
                          buttonClassName={classNames('create-folder-btn')}
                        />
                      ) : null}
                    </>
                  )
                  : null}
                {
                  showUploadDocument && !inGlobalSearch && !inSmartDrawer && uploadAllow && (
                    <Tooltip
                      placement="bottom"
                      getPopupContainer={(e: HTMLElement) => e}
                      className="triggers-bullet-tooltip h-fit"
                      color="#fff"
                      title="Upload in Document Hub"
                    >
                      <span>
                        <GlobalButton
                          title={isMob ? '' : 'Upload document'}
                          IconLeft={<UploadDocumentIcon color="#fff" />}
                          LeftSpace={smMob ? '' : '12px'}
                          PaddingSm="5px 10px"
                          innerSpace="8.5px 14px"
                          heightSm="30px"
                          height="30px"
                          bgColor={SecondaryColor}
                          textColor="#fff"
                          onButtonClick={handleUploadClick}
                          buttonClassName={classNames('upload-document-btn', { highlightedComponent: isHighlight && currentType === 'document_hub_panel' })}
                        />
                      </span>
                    </Tooltip>
                  )
                }
              </div>
            )
          }
        </div>
      )}
      {inSmartDrawer ? (
        <div className="sap-document-hub-header-sub-primary">
          <div className="radio-text">
            <Radio onClick={() => dispatch(actions.setSapRadio('document'))} checked={sapRadio === 'document'} disabled={currentView === 'document'} />
            <span className="radio-title">
              Document hub
            </span>
          </div>
          <div className="radio-text">
            <Radio onClick={() => dispatch(actions.setSapRadio('custom'))} checked={sapRadio === 'custom'} />
            <span className="radio-title">
              Custom selection
            </span>
          </div>
        </div>
      ) : null}
      {visible ? (
        <CreateFolderPopup />
      ) : null}
    </StyleSheet>
  );
};

DocumentHubHeader.defaultProps = defaultProps;
export default DocumentHubHeader;
